import styled from 'styled-components';
import { motion } from 'framer-motion6';

export const CardsContainer = styled(motion.div)`
  position: relative;
  display: flex;
  min-width: min-content;
  padding-top: 31px;
  padding-bottom: 35px;
`;
